import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_COURSE_MAP } from "actions/courseMap";

const loadingCourseMap = (state = initialState.loadingCourseMap, action: any) => {
  switch (action.type) {
    case pending(GET_COURSE_MAP):
      return true;
    case fulfilled(GET_COURSE_MAP):
    case failed(GET_COURSE_MAP):
      return false;
    default:
      return state;
  }
};

export default loadingCourseMap;
